import { render } from "./AddNewCategory.vue?vue&type=template&id=06cd615f&scoped=true"
import script from "./AddNewCategory.vue?vue&type=script&lang=js"
export * from "./AddNewCategory.vue?vue&type=script&lang=js"

import "./AddNewCategory.vue?vue&type=style&index=0&id=06cd615f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cd615f"]])

export default __exports__